import React, { useState } from 'react'
import css from './DashboardWrapper.module.css'
import { Menu as MenuIcon, ChevronLeft } from 'react-feather'
import { Menu, MenuItem } from '@szhsin/react-menu'
import '@szhsin/react-menu/dist/index.css'
import { Link, RouteComponentProps, withRouter } from 'react-router-dom'
import { enterpriseLockupLogoLight } from '../../assets/viveka-logos'
import { logout } from '../../pages/Auth/helpers'
import { getAdminRole } from '../../helpers/auth'
import { Avatar } from '@mantine/core'

interface PropsI extends RouteComponentProps {
  title?: string
  page?: string
}

const navItems = [
  { to: '/dashboard', page: 'dashboard', label: 'Dashboard' },
  { to: '/budget-request', page: 'budget-request', label: 'Budget requests' },
  { to: '/company', page: 'company', label: 'Companies' },
  { to: '/users', page: 'user', label: 'Users' },
  { to: '/all-users', page: 'all-users', label: 'All users' },
  { to: '/invoice/coaches', page: 'coach', label: 'Coach invoices' },
  { to: '/subscriptions', page: 'subscriptions', label: 'Subscriptions' },
  { to: '/subscriptions/automation', page: 'subscriptions-automation', label: 'Automation' },
  { to: '/tracking', page: 'tracking', label: 'Tracking' },
  { to: '/reports', page: 'reports', label: 'Reports', reportViewer: true },
]

const DashboardWrapper: React.FC<PropsI> = (props) => {
  const { children, title, page, history } = props

  const [isNavOpen, setIsNavOpen] = useState(false)
  const isReportViewer = getAdminRole() === 'report-viewer'

  const menuItemStyles = {
    hover: {
      backgroundColor: css.primaryColor,
      color: 'white',
    },
    active: {
      backgroundColor: css.primaryColor,
      color: 'white',
    },
  }

  const onLogoutClick = () => {
    logout()
    history.push('/auth/login')
  }

  return (
    <div className={css.base}>
      <div className={`${css.menu_base} ${isNavOpen && css.menu_open} bg-[#0B1D3A]`}>
        <div className={`${css.menu_nav_top} px-5 py-6 justify-start gap-2`}>
          <Link to={isReportViewer ? '/reports' : '/'} className="flex items-center gap-2 no-underline">
            <img alt={'logo'} src={enterpriseLockupLogoLight} className="h-8" />
          </Link>
          <ChevronLeft
            className={`${css.menu_close_button} text-white`}
            onClick={() => setIsNavOpen(false)}
          />
        </div>

        <div className="flex flex-col gap-1 px-3 mt-2">
          {navItems.filter((item) => !isReportViewer || item.reportViewer).map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`${
                page === item.page
                  ? 'bg-[#3882F6] text-white font-bold'
                  : 'text-[#A9B8D6] font-medium hover:bg-[#132D5E]'
              } px-4 py-3 rounded-lg no-underline transition-colors`}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>

      <div className={`${css.content_base} bg-[#F4F7FC]`}>
        <div className={`${css.nav_bar} bg-[#F4F7FC]`}>
          <MenuIcon onClick={() => setIsNavOpen(true)} />
          <p className={`${css.nav_title} text-[#0B1D3A]`}>{title}</p>
          <div className={css.nav_actions}>
            <Menu
              direction="left"
              menuButton={
                <div className={css.avatar_wrapper}>
                  <Avatar size={40}></Avatar>
                </div>
              }
            >
              <MenuItem onClick={() => onLogoutClick()} styles={menuItemStyles}>
                Logout
              </MenuItem>
            </Menu>
          </div>
        </div>
        <div className={css.content}>{children}</div>
      </div>
    </div>
  )
}

export default withRouter(DashboardWrapper)
